<template>
  <div class="">
    <iframe
      src="http://157.245.87.136:4000/public/dashboard/08412657-a9a3-49b0-8e37-280019433f2a"
      frameborder="0"
      width="100%"
      height="4000"
      allowtransparency
    ></iframe>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Stats",
  components: {},
  data: function() {
    return {};
  },
  created: function() {},
  methods: {},
  beforeMount: function() {},
  mounted: function() {},
  computed: {},
  watch: {}
};
</script>